import { openGiftShowcaseModal, openHowGiftlyWorksModal } from '@consumer/services/modals'
import type GiftTemplate from '@consumer/types/GiftTemplate'

declare global {
  interface Window {
    currentGift: GiftTemplate
    InertiaProps: Record<string, any> | undefined
  }
}

function onExactClick (selector: string, fn: (el: HTMLElement) => void) {
  document.querySelectorAll<HTMLElement>(selector).forEach((el) => {
    el.addEventListener('click', (event) => {
      if (event.metaKey || event.shiftKey || event.ctrlKey || event.altKey) return
      event.preventDefault()
      fn(el)
    })
  })
}

export function setupHowItWorks () {
  onExactClick('.how-it-works-modal-link', () => {
    openHowGiftlyWorksModal()
  })

  onExactClick('.how-it-works-demo-modal-link', () => {
    // New greeting-card 2.0 demo: a generic sample gift fetched by the modal.
    if (window.InertiaProps?.featureFlags?.newStaticGreetingCardFlow) {
      openGiftShowcaseModal({ mode: 'demo' })
      return
    }

    if (window.currentGift && !window.currentGift.greeting) {
      window.currentGift.greeting = {
        message: 'Thank you for everything! I hope you have a great day. Looking forward to seeing you soon.',
        from: 'Me',
        to: 'You',
      }
    }

    openHowGiftlyWorksModal({ initialStep: 'preview-landing', gift: window.currentGift })
  })
}
